import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardText, Badge, Spinner, FormGroup, Label, Input, Button } from 'reactstrap';
import { Entrycameramonitor } from '../../../../api/EntryCameraMonitorifl';

const FaceCardV2 = ({ detection, loading, onStatusUpdate, handleImageClick }) => {
    const role = JSON.parse(localStorage.getItem('role'))
    const [sopViolation, setSopViolation] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formatDateTime = (dateTimeStr) => {
        const date = new Date(dateTimeStr);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    };

    const handleSopViolationChange = (value) => {
        setSopViolation(value);
    };

    console.log("Dekhao SOP Violation", sopViolation);

    const HandleQAResponse = async () => {
        if (sopViolation === null) return; // Don't submit if no option selected

        setIsSubmitting(true);
        try {
            const payload = {
                log_id: detection.log_id || "",
                client: true,
                verified: sopViolation // true for "Yes", false for "No"
            }
            console.log("Submitting payload:", payload);
            const response = await Entrycameramonitor.upDateStatus(payload);
            console.log("API Response:", response);

            // If API call is successful, update the specific detection
            if (response && response.status === 200 && onStatusUpdate) {
                onStatusUpdate(detection.log_id, sopViolation);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Remove the useEffect that was calling HandleQAResponse on mount
    // useEffect(() => {
    //     HandleQAResponse();
    // }, [])

    // Check if card should be disabled based on client_verified
    const isCardDisabled = role == 'qa' ? detection.client_verified !== null && detection.client_verified !== undefined 
                                        :
                                        detection.ai_verified !== null && detection.ai_verified !== undefined 

    return loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <Spinner style={{ width: '2.5rem', height: '2.5rem', color: '#8B9736' }} />
        </div>
    ) : (
        <Card className="mb-2 face-detection-card">
            <img
                top
                src={detection?.face_image_url}
                alt={`Face of ${detection.employee_name}`}
                className="face-image"
                onClick={()=> handleImageClick(detection?.face_image_url)}
            />
            <CardBody className='p-2'>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted fw-bold">{detection.employee_name}</small>
                    <Badge
                        color={detection.blacklisted ? "danger" : "primary"}
                        pill
                    >
                        {detection.blacklisted ? "Blacklisted" : detection.employee_designation}
                    </Badge>
                </div>
                <CardText className="mb-0">
                    <small className="text-muted">ID: {detection.employee_id}</small>
                </CardText>
                <CardText className="mb-0">
                    <small className="text-muted">Camera: {detection.camera_name}</small>
                </CardText>
                <CardText className="mb-0">
                    <small className="text-muted">Position: {detection.camera_position_no}</small>
                </CardText>
                <CardText className="mb-0">
                    <small className="text-muted">Time: {formatDateTime(detection.detection_datetime)}</small>
                </CardText>
                <CardText className="mb-0">
                    <Badge
                        color={detection.sop_followed ? "success" : "warning"}
                        pill
                    >
                        {detection.sop_followed ? "SOP Followed" : "SOP Not Followed"}
                    </Badge>
                </CardText>
            </CardBody>

            {/* SOP Violation Question Section */}
            <div className="sop-violation-section p-3 border-top" style={{
                borderColor: '#dee2e6',
                backgroundColor: '#f8f9fa'
            }}>
                <div className="text-center mb-3">
                    <h6 className="mb-0 text-muted fw-bold">Safety Violations</h6>
                </div>

                {/* Show verification status if already verified */}
                {isCardDisabled ? (
                    <div className="text-center mb-3">
                        <p className="mb-0 text-muted">Is any safety violation observed?</p>
                        <hr className="my-2" style={{ borderColor: '#6c757d' }} />
                        <div className="d-flex justify-content-center align-items-center">
                            {detection.client_verified === false ? (
                                <>
                                    <span className="text-danger me-2">✕</span>
                                    <span className="text-muted">No Violation Was Detected</span>
                                </>
                            ) : (
                                <>
                                    <span className="text-success me-2">✓</span>
                                    <span className="text-muted">Violation was Detected</span>
                                </>
                            )}
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="text-center mb-3">
                            <p className="mb-0 text-muted">Is there any <b>Violation observed?</b> </p>
                            <hr className="my-2" style={{ borderColor: '#6c757d' }} />
                        </div>

                        {/* Radio buttons - only show if not disabled */}
                        <div className="d-flex justify-content-center gap-4">
                            <FormGroup check className="d-flex align-items-center">
                                <Input
                                    type="radio"
                                    name={`sopViolation-${detection.employee_id}-${detection.detection_datetime}`}
                                    id={`yes-${detection.employee_id}-${detection.detection_datetime}`}
                                    checked={sopViolation === true}
                                    onChange={() => handleSopViolationChange(true)}
                                    className="me-2"
                                />
                                <Label
                                    check
                                    for={`yes-${detection.employee_id}-${detection.detection_datetime}`}
                                    className="mb-0 text-muted"
                                >
                                    Yes
                                </Label>
                            </FormGroup>
                            <FormGroup check className="d-flex align-items-center">
                                <Input
                                    type="radio"
                                    name={`sopViolation-${detection.employee_id}-${detection.detection_datetime}`}
                                    id={`no-${detection.employee_id}-${detection.detection_datetime}`}
                                    checked={sopViolation === false}
                                    onChange={() => handleSopViolationChange(false)}
                                    className="me-2"
                                />
                                <Label
                                    check
                                    for={`no-${detection.employee_id}-${detection.detection_datetime}`}
                                    className="mb-0 text-muted"
                                >
                                    No
                                </Label>
                            </FormGroup>
                        </div>

                        {/* Submit Button - Show when any option is selected (including false/No) */}
                        {sopViolation !== null && (
                            <div className="text-center mt-3">
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={HandleQAResponse}
                                    disabled={isSubmitting}
                                    className="px-4"
                                >
                                    {isSubmitting ? (
                                        <>
                                            <Spinner size="sm" className="me-2" />
                                            Submitting...
                                        </>
                                    ) : (
                                        'Submit'
                                    )}
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </Card>
    );
};

export default FaceCardV2;